import React from 'react';
import styled from 'styled-components';

import {
  Title,
  Wrapper,
  Card
} from '../../../ChangeStudiesOption/info/components';
import WhiteContainer from '@/presentation/modules/procedures/components/ContainerProcedure/WhiteContainer';
import ReusablePin from '../../../../../../../reusables/Pin';
import Link from '@/presentation/reusables/Link';

const ProcedureInformationText = styled.div`
  ul {
    list-style: disc;
    margin-left: 24px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }
`;

interface ProcedureInfoComponentProps {
  inRegister?: boolean;
}

const ProcedureInfoComponent = ({
  inRegister
}: ProcedureInfoComponentProps) => (
  <>
    <WhiteContainer inRegister={inRegister}>
      <Wrapper>
        <Card>
          <Title>Información del trámite:</Title>
          <div>
            <ProcedureInformationText>
              Solicita tu trámite siguiendo los pasos especificados.
              <b>
                *Recuerda que el precio es por examen y depende del curso.
              </b>{' '}
              <br />
              <Title style={{ marginTop: '8px' }}>
                ¿Qué requisitos necesito?
              </Title>
              <ul>
                <li>Estar matriculado en el presente ciclo.</li>
                <li>
                  Tener 1 examen parcial o final con{' '}
                  <b>{'NS (que significa "No se presentó")'}</b> en algún curso
                  que estés llevando actualmente.
                </li>
              </ul>
              <br />
              <Title>
                Cronograma: te dejamos las fechas máximas de solicitud según tu
                caso
              </Title>
              <ul
                style={{
                  marginRight: 16
                }}
              >
                <li>
                  {
                    'Si tu examen final fue el 16 julio o del 21 al 25 de julio y no lo rendiste, entonces tu fecha máxima para solicitar el trámite será el 26 de julio (Hasta la 1pm). Tu examen rezagado será el día 27 de julio.'
                  }
                </li>
                <li>
                  {
                    'Si tu examen final fue del 26 al 27 de julio y no lo rendiste, entonces tu fecha máxima para solicitar el trámite será el 28 de julio (Hasta la 1pm). Tu examen rezagado será el día 30 de julio.'
                  }
                </li>
              </ul>
              <br />
              Para más informacion revisa{' '}
              <Link
                linkType="external"
                url="https://bit.ly/3SQr310"
                linkName="aquí."
              />
              <br />
              <br />
              <Title>Consideraciones:</Title>
              <ul>
                <li>
                  La fecha máxima es <b>hasta el pago</b> hecho y cerrada la
                  solicitud, sino no se considerará.
                </li>
                <li>
                  Recuerda que el precio <b>es por examen</b> y depende del
                  curso.
                </li>
              </ul>
              <ReusablePin
                message={
                  'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
                }
                style={{ marginTop: '16px' }}
              />
              <br />
            </ProcedureInformationText>
          </div>
        </Card>
      </Wrapper>
    </WhiteContainer>
    <div
      style={{
        marginTop: 12
      }}
    >
      <WhiteContainer>
        <Wrapper>
          <Card>
            <Title>Pasos a seguir:</Title>
            <div>
              <ol
                style={{
                  listStyleType: 'lower-aplha',
                  marginLeft: '16px',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '20px',
                  color: '#161D1F'
                }}
              >
                <li>
                  Registra tu solicitud escogiendo el curso que deseas rezagar.
                </li>
                <li>Realiza el pago en nuestras opciones disponibles.</li>
                <li>
                  Recibe la conformidad u observaciones a tu correo una vez
                  finalizado el trámite.
                </li>
              </ol>
            </div>
          </Card>
        </Wrapper>
      </WhiteContainer>
    </div>
  </>
);

export { ProcedureInfoComponent };
